import LegalLayout from "@/components/LegalLayout";
import OrganizationJsonLd from "@/components/OrganizationJsonLd";
import useSiteContent from "@/hooks/useSiteContent";

const TOC = [
    { id: "brand", label: "The brand" },
    { id: "what", label: "What we do" },
    { id: "what-we-dont", label: "What we do NOT do" },
    { id: "entity", label: "Legal entity" },
    { id: "contact", label: "Contact" },
];

const ABOUT_DEFAULTS = {
    about_hero: {
        eyebrow: "About Doctor Digital Identity Platform",
        title: "About Doctor Digital Identity Platform",
        intro: "Doctor Digital Identity Platform (DDIP) is a professional identity and brand platform built exclusively for practicing doctors in India. We help verified medical practitioners publish a polished, SEO-ready digital identity page in minutes — with AI-composed biographies, QR-based verified cards, and a purpose-built content engine.",
    },
};

export default function About() {
    const { content } = useSiteContent(ABOUT_DEFAULTS);
    const hero = content.about_hero || ABOUT_DEFAULTS.about_hero;
    return (
        <LegalLayout title={hero.title} updated="February 2026" toc={TOC}>
            <OrganizationJsonLd />
            <p data-testid="about-intro">{hero.intro}</p>

            <h2 id="brand">The brand</h2>
            <p>
                The trading brand is <strong>Doctor Digital Identity Platform</strong>
                {" "}(product name: <em>Doctor Digital ID</em>). The service is
                owned and operated by <strong>HUMANITYFIRST SOFTWARE TECHNOLOGY
                PRIVATE LIMITED</strong>, a company incorporated in India.
            </p>

            <h2 id="what">What we do</h2>
            <ul>
                <li>
                    <strong>Digital identity websites</strong> for individual
                    doctors: a public /dr/&lt;slug&gt; page with biography, credentials,
                    consultation info, gallery, articles, and enquiry contact.
                </li>
                <li>
                    <strong>AI-composed content</strong>: professional biography,
                    profile summary, SEO title/meta, FAQs, and specialty descriptions,
                    grounded strictly in the doctor&rsquo;s provided data — no
                    fabrication.
                </li>
                <li>
                    <strong>Package-based subscription</strong> across five tiers
                    (Starter, Professional, Premium, Elite, Legacy Platinum),
                    covering 20&ndash;121 features from digital branding to
                    social/reputation and analytics.
                </li>
                <li>
                    <strong>Verified QR card</strong> that patients can scan to
                    reach the doctor&rsquo;s official profile page directly.
                </li>
            </ul>

            <h2 id="what-we-dont">What we do NOT do</h2>
            <p>
                DDIP is <strong>NOT</strong> a medical diagnostic, treatment,
                prescription, or emergency service. We do not provide medical
                advice, appointment brokering, telemedicine, drug delivery, or
                any clinical service directly to patients. All medical
                consultations and decisions remain strictly between the doctor
                and the patient.
            </p>

            <h2 id="entity">Legal entity</h2>
            <p>
                <strong>HUMANITYFIRST SOFTWARE TECHNOLOGY PRIVATE LIMITED</strong>
                <br />
                Registered office: A-803 Palatial Height, Chandivali Farm Road,
                Andheri, Mumbai, Maharashtra 400072, India.
                <br />
                Governing law: laws of India; jurisdiction: courts of Mumbai,
                Maharashtra.
            </p>

            <h2 id="contact">Contact</h2>
            <p>
                Support &amp; enquiries: <a href="tel:+917722090290">+91 7722090290</a>
                <br />
                Address: as above.
                <br />
                For full contact channels, refunds, and legal correspondence
                see <a href="/contact">/contact</a>.
            </p>
        </LegalLayout>
    );
}
